import styled from 'vue-styled-components';

const theme = { font: String };

const ThemedDatePlaceText = styled('span', theme)`
        font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
`;

export default ThemedDatePlaceText
